import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

const addGiftWrapToCart = async (items) => {
  return await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    body: JSON.stringify(items),
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(async response => {
      return response.json();
    })
    .catch(error => {
      console.error('Error during adding to cart:', error);
    });
}

$(function () {
  const $giftModalOpener = $('.gift-modal-opener');
  const $giftModal = $('.gift__modal');

  let $giftModalProducts = $('.gift__modal__content__products');
  let $giftModalSubmit = $('.gift__modal__content__actions > button');
  let $giftModalMessage = $('.gift__modal__content__message');
  let $giftModalMessageArea = $('.gift__modal__content__message #gift-message');

  if (!$giftModalOpener.length || !$giftModal.length) return;

  const $giftModalClose = $('.gift__modal__close');

  $giftModalOpener.on('click', function () {

    const currentGiftModal = '#gift__modal--' + $(this).parents('.cart__form__row--product').attr('data-group');

    $giftModalProducts = $('.gift__modal__content__products', $(currentGiftModal));
    $giftModalSubmit = $('.gift__modal__content__actions > button', $(currentGiftModal));
    $giftModalMessage = $('.gift__modal__content__message', $(currentGiftModal));
    $giftModalMessageArea = $('.gift__modal__content__message #gift-message', $(currentGiftModal));

    $(currentGiftModal).addClass('open');
    $('body').addClass('gift-modal-open');

    showBackdrop();
  });

  $giftModalClose.on('click', function (e) {
    e.stopPropagation();
    $giftModal.removeClass('open');
    $('body').removeClass('gift-modal-open');

    hideBackdrop();
  });

  $('.gift__modal__content__product', $giftModalProducts).on('click', function (e) {
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $giftModalSubmit.prop('disabled', false);
    $giftModalSubmit.attr('data-item', $(this).attr('data-item'));
    $giftModalMessage.addClass('open');
  });


  $giftModalSubmit.on('click', async function (e) {
    e.stopPropagation();

    await addGiftWrapToCart({
      items: [{
        id: $(this).data('item'),
        quantity: 1,
        properties: {
          '_UniqueId': $(this).attr('data-group'),
          'Message': $giftModalMessageArea.val(),
        }
      }]
    });

    $giftModal.removeClass('open');
    $('body').removeClass('gift-modal-open');

    atQuery('min', 'md', () => {
      hideBackdrop();
    });

    location.reload();
  });
});
